cdm_blocks.fn.ready(()=>{
    if(document.querySelector('.slider-quotes')){
        var slider = tns({
            container: '.slider-quotes',
            items: 1,
            controls: true,
            controlsText: ['<i class="fa-regular fa-chevron-left"></i>', '<i class="fa-regular fa-chevron-right"></i>'],
            nav: true,
            navPosition: "bottom",
            mouseDrag: true,
            autoplay: true,
            autoplayTimeout: 10000,
            gutter: 10,
            autoplayButtonOutput: false
        });
    }

    if(document.querySelector('.grid-quotes')){
        var grid = document.querySelector('.grid-quotes');
        var msnry = new Masonry( grid, {
            // options...
            itemSelector: '.wp-block-quote',
            gutter: 25,
        });
    }
});